import React from 'react';
import { motion } from 'framer-motion';
import { UsersIcon } from 'lucide-react';
export function AboutSection() {
  return <section id="despre" className="bg-brand-ivory section-padding relative overflow-hidden" data-id="element-39">
      {/* Decorative Background Elements */}
      <svg className="absolute top-20 right-0 w-64 h-64 text-brand-beige -z-10" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg" data-id="element-40">
        <path fill="currentColor" d="M42.7,-73.4C55.9,-66.5,67.6,-55.4,76.5,-42.1C85.4,-28.8,91.5,-13.3,90.4,1.7C89.3,16.7,81.1,31.2,71.2,43.4C61.3,55.6,49.7,65.5,36.5,72.4C23.3,79.3,8.5,83.2,-6.1,82.8C-20.7,82.4,-35.1,77.7,-47.8,69.6C-60.5,61.5,-71.5,50.1,-78.6,36.4C-85.7,22.7,-88.9,6.7,-86.1,-8.5C-83.3,-23.7,-74.5,-38.1,-62.6,-49.2C-50.7,-60.3,-35.7,-68.1,-21.5,-72.6C-7.3,-77.1,6.1,-78.3,20.4,-76.8C34.7,-75.3,49.9,-71.1,42.7,-73.4Z" transform="translate(100 100)" data-id="element-41" />
      </svg>

      <div className="container-custom" data-id="element-42">
        <div className="grid md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-43">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="order-2 md:order-1 relative h-[500px] md:h-[650px] w-full" data-id="element-44">
            {/* Decorative Dots Pattern */}
            <svg className="absolute -top-6 -right-6 w-32 h-32 text-brand-gold/40 -z-10" viewBox="0 0 100 100" data-id="element-45">
              <defs data-id="element-46">
                <pattern id="dots-about" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse" data-id="element-47">
                  <circle cx="3" cy="3" r="3" fill="currentColor" data-id="element-48" />
                </pattern>
              </defs>
              <rect x="0" y="0" width="100" height="100" fill="url(#dots-about)" data-id="element-49" />
            </svg>

            {/* Accent Bar */}
            <div className="absolute top-10 -left-4 w-8 h-32 bg-brand-coral rounded-full -z-10" data-id="element-50"></div>

            {/* Main Image with Offset Border */}
            <div className="absolute inset-0 border-2 border-brand-gold rounded-[24px] translate-x-4 translate-y-4 -z-10" data-id="element-51"></div>

            <div className="w-full h-full rounded-[24px] rounded-tl-[80px] overflow-hidden shadow-card relative z-10 bg-white" data-id="element-52">
              <img src="https://cdn.magicpatterns.com/uploads/wvUBHAy6VhqaRqNiVJPB6X/Cristina_poze_%285%29.jpg" alt="Cristina Geană - Psiholog Clinician" className="w-full h-full object-cover" data-id="element-53" />
            </div>

            {/* Floating Stats Card */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4,
            duration: 0.5
          }} className="absolute bottom-10 -right-8 bg-white p-5 rounded-[16px] shadow-card flex items-center gap-4 z-20 border border-brand-beige" data-id="element-54">
              <div className="w-12 h-12 rounded-full bg-brand-navy/10 flex items-center justify-center text-brand-navy" data-id="element-55">
                <UsersIcon size={24} data-id="element-56" />
              </div>
              <div data-id="element-57">
                <p className="font-montserrat font-bold text-[20px] text-brand-navy leading-none mb-1" data-id="element-58">
                  21
                </p>
                <p className="font-source text-[14px] text-brand-textSecondary leading-none" data-id="element-59">
                  specialiști în echipă
                </p>
              </div>
            </motion.div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} className="order-1 md:order-2 flex flex-col gap-6 relative z-10" data-id="element-60">
            <div data-id="element-61">
              <h2 className="text-[36px] md:text-[42px] mb-2" data-id="element-62">
                Cristina Geană
              </h2>
              <p className="font-montserrat font-medium text-[14px] md:text-[16px] text-brand-textSecondary uppercase tracking-wide leading-relaxed" data-id="element-63">
                Psiholog Clinician{' '}
                <span className="text-brand-gold mx-1" data-id="element-64">•</span>{' '}
                Supraspecializată în Dezvoltarea și Terapia Copilului Mic{' '}
                <span className="text-brand-gold mx-1" data-id="element-65">•</span> Formată în
                Analiza Comportamentală (ABA)
              </p>
            </div>

            <div className="space-y-4 text-brand-text" data-id="element-66">
              <p data-id="element-67">
                Sunt Cristina Geană și de peste 11 ani lucrez cu copii mici și
                cu familiile lor. Am început în camera de terapie, lucrând
                direct cu copii cu întârzieri în dezvoltare și tulburări din
                spectrul autist. Astăzi coordonez o echipă de 21 de specialiști
                într-un centru de psihologie și terapie.
              </p>
              <p data-id="element-68">
                Am văzut sute de copii care nu vorbeau, care nu se jucau, care
                păreau într-o lume a lor. Și i-am văzut pe aceiași copii
                începând să comunice, să caute privirea mamei, să spună primele
                cuvinte.
              </p>
              <p data-id="element-69">
                Știu exact ce e normal și ce nu la fiecare vârstă, nu din cărți,
                ci din experiența directă cu copiii și din ceea ce am învățat de
                la propriii mei doi băieți. Prin Programul CRESC, îți ofer tot
                ce am învățat în acești ani, structurat pas cu pas, ca să poți
                să îți ajuți copilul acasă, prin joc și conectare.
              </p>
            </div>

            <div className="mt-6 bg-white p-8 rounded-[16px] shadow-sm border border-brand-beige relative overflow-hidden" data-id="element-70">
              <div className="absolute top-0 right-0 w-32 h-32 bg-brand-gold/5 rounded-bl-full" data-id="element-71"></div>
              <h3 className="text-[24px] mb-6 relative z-10" data-id="element-72">Misiunea mea</h3>
              <ul className="space-y-4 relative z-10" data-id="element-73">
                {['De la îngrijorare și confuzie, la claritate și încredere', 'De la căutare fără rost, la un plan clar pas cu pas', 'De la "nu știu ce să fac" la "știu exact cum să îl ajut"'].map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-74">
                    <span className="w-2 h-2 rounded-full bg-brand-gold mt-2.5 flex-shrink-0" data-id="element-75"></span>
                    <span className="text-brand-text" data-id="element-76">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}